import React, { Component } from 'react';
import styled from 'styled-components';

class Dropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isListOpen: false,
    }
    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.close();
    }
  }

  close = () => {
    if (this.state.isListOpen === true) {
      this.setState({ isListOpen: false }, document.removeEventListener('mousedown', this.handleClickOutside));
    }
  }

  open = () => {
    if (this.state.isListOpen === false) {
      this.setState({ isListOpen: true }, document.addEventListener('mousedown', this.handleClickOutside));
    } else {
      this.close();
    }
  }

  selectItem = (item, value) => {
    // console.log(item, value);
    if (item === '') {
      this.setState({ headerTitle: this.props.title}, () => {
        this.props.selected(item, value);
      });
    } else {
      this.setState({ headerTitle: item}, () => {
        this.props.selected(item, value);
      });
    }
    this.close();
  }

  render () {
    const { isListOpen } = this.state;
    const { title, list, name, value, width, height, option, active, addAll, error } = this.props;

    const WrapDiv = styled.div`
      position: relative;
      & button {
        box-shadow: none;
        text-shadow: none;
        cursor: pointer;
      }
    `;
    const ToggleButton = styled.button`
      min-width: ${width};
      height: 38px;
      background-color: #ffffff;
      color: #1E2228;
      font-size: 14px;
      font-weight: 400;
      border-radius: 6px;
      border: 1px solid ${props => props.open ? '#1B49EA' : `${props.error ? '#E74C3C' : '#c9c9c9'}`};
      display: flex;
      align-items: center;
      padding: 13px 35px 13px 15px;
      margin: 0px;
      position: relative;
      &:after {
        content: '';
        position: absolute;
        z-index: 0;
        right: 15px;
        border-width: ${props => props.open ? '0px 5px 5px 5px' : '5px 5px 0px 5px'};
        border-color: ${props => props.open ? 'transparent transparent #A1A1A1 transparent' : '#A1A1A1 transparent transparent transparent'};
        border-style: solid;
      }
      & div {
        white-space: nowrap;
        overflow: hidden;
      }
    `;
    const List = styled.div`
      max-height: 50vh;
      overflow-y: scroll;
      display: flex;
      flex-direction: column;
      position: absolute;
      z-index: 4;
      border-radius: 4px;
      border: 1px solid #E6E6E6;
    `;
    const ListItem = styled.button`
      width: ${width};
      background-color: #ffffff;
      color: #1E2228;
      font-size: 14px;
      border-bottom: 1px solid #E6E6E6;
      padding: 8px 15px;
      margin: 0px;
      display: flex;
      font-weight: ${props => props.active ? '700' : 'normal'};
      white-space: nowrap;
      &:hover {
        background-color: #f6f6f6;
      }
    `;

    let headerTitle = title;
    if (typeof active !== 'undefined') {
      if (active !== '' && list && list.length > 0) {
        for (let x = 0; x < list.length; x++) {
          if (active === list[x][option]) headerTitle = list[x][option];
        }
      }
    }

    return (
      <WrapDiv ref={this.wrapperRef} style={{ width: width, height: height }}>
        <ToggleButton
          onClick={this.open}
          open={isListOpen}
          style={{ color: headerTitle === title ? '#7b7b7b' : '#1E2228', width: width, height: height }}
          error={error}
        >
          <div>{headerTitle}</div>
        </ToggleButton>
        { isListOpen && (
          <List>
            { typeof addAll !== 'undefined' && addAll === true ?
              <ListItem
                key={`all_${name}`}
                onClick={() => this.selectItem('', '')}
                style={{ minWidth: this.props.width }}
              >
                All
              </ListItem>
            : ''
            }
            { list && list.length > 0 && list.map((item, itemIndex) => {
              let isActive = false;
              if (typeof active !== 'undefined' && typeof active[name] !== 'undefined' && active[name] === item[value]) {
                isActive = true;
              }
              return (
                <ListItem
                  key={`${item[option]}_${itemIndex}`}
                  onClick={() => this.selectItem(item[option], item[value])}
                  active={isActive}
                  style={{ width: this.props.width }}
                >
                    {/* {console.log(item[option])} */}
                  {item[option]}
                </ListItem>
              )
            })}
          </List>
        )}
      </WrapDiv>
    );
  }
}

export default Dropdown;